import { Box } from "@mui/material";
import CustomShimmer from "../../../components/CustomShimmer/CustomShimmer";

const ProductCardSkeleton = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap=".25rem"
      marginTop="1rem"
    >
      <CustomShimmer width="3rem" height="3rem" borderRadius=".25rem" />
      <CustomShimmer width="2rem" height=".5rem" borderRadius=".25rem" />
      <CustomShimmer width="4rem" height=".5rem" borderRadius=".25rem" />
    </Box>
  );
};

export default ProductCardSkeleton;
